export const recallsConfigItems = {
  recallCenter: {
    useCmsRecalls: true,
    eligibleRecalls: null,
    landingFaq: [
      {
        cmsTitle: 'recall_howCanITell_title',
        cmsContent: 'rtext_recallCenter_faq_howCanITell',
        trackLink: 'recalls:How can I tell',
        trackProp: 'recalls:link:How can I tell'
      },
      {
        cmsTitle: 'recall_ifIHaveNotReceived_title',
        cmsContent: 'rtext_recallCenter_faq_ifIHaveNotReceived',
        trackLink: 'recalls:If I have not received',
        trackProp: 'recalls:link:If I have not received'
      },
      {
        cmsTitle: 'recall_whoShouldIContact_title',
        condition: true,
        cmsContentTrue: 'rtext_recallCenter_faq_whoShouldIContactNotPosh',
        cmsContentFalse: 'rtext_recallCenter_faq_whoShouldIContactPosh',
        trackLink: 'recalls:Who should I contact',
        trackProp: 'recalls:link:Who should I contact'
      },
      {
        cmsTitle: 'recall_moreInfo_title',
        cmsContent: 'rtext_recallCenter_faq_moreInfo',
        trackLink: 'recalls:Where can I find',
        trackProp: 'recalls:link:How can I tell'
      }
    ],
    foundResultsFaq: [
      {
        cmsTitle: 'recall_recallIncomplete_title',
        cmsContent: 'rtext_recallCenter_faq_recallIncomplete',
        trackLink: 'recall:accordian:incomplete',
        trackProp: 'recall:accordian:incomplete'
      },
      {
        cmsTitle: 'recall_recallIncompleteNoRemedy_title',
        cmsContent: 'rtext_recallCenter_faq_recallIncompleteNoRemedy',
        trackLink:
          'recalls:Vehicle recall incomplete status no remedy available',
        trackProp:
          'recalls:link:Vehicle recall incomplete status no remedy available'
      },
      {
        cmsTitle: 'recall_noRecallLetterStillRepaired_title',
        cmsContent: 'rtext_recallCenter_faq_noRecallLetterStillRepaired',
        trackLink: 'recalls:Vehicle recall no recall letter still repaired',
        trackProp:
          'recalls:link:Vehicle recall no recall letter still repaired'
      },
      {
        cmsTitle: 'recall_recallListedAfterRepair_title',
        cmsContent: 'rtext_recallCenter_faq_recallListedAfterRepair',
        trackLink: 'recalls:Vehicle repaired but it is still listed in recall',
        trackProp:
          'recalls:link:Vehicle repaired, but it is still listed in recall'
      },
      {
        cmsTitle: 'recall_precautionaryRecall_title',
        cmsContent: 'rtext_recallCenter_faq_precautionaryRecall',
        trackLink: 'recalls:Vehicle precautionary recall',
        trackProp: 'recalls:link:Vehicle precautionary recall'
      }
    ],
    noResultsFoundFaq: [
      {
        cmsTitle: 'recall_iHeardTheYMM_title',
        cmsContent: 'rtext_recallCenter_faq_iHeardTheYMM',
        trackLink: 'recalls:I heard the YMM I own is in recall',
        trackProp: 'recalls:link:I heard the YMM I own is in recall'
      }
    ]
  }
};
